import React, { createContext, useContext } from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';

import useNetwork from './hook';
import { usePassiveTimer } from './passive-timer-hook';

export interface NetworkCtx {
  isNetworkConnected: boolean;
  isInternetReachable: boolean;
  sanityEndpoints: {
    graphql: string;
    groq: string;
    graphqlV2: string;
  };
  startCheckSlowResponse: () => void;
  stopCheckSlowResponse: () => void;
  isSlow: boolean;
  isRunning: boolean;
  elapsedMs: number;
}

export const NetworkContext = createContext<NetworkCtx>({} as NetworkCtx);
export const useNetworkContext = () => useContext(NetworkContext);

export function NetworkProvider({ children }: IBaseProps) {
  const value = useNetwork();
  const passive = usePassiveTimer();
  return (
    <NetworkContext.Provider value={{ ...value, ...passive }}>{children}</NetworkContext.Provider>
  );
}

export default NetworkContext.Consumer;
